import React from "react";
import PropTypes from "prop-types";
import {initials} from "../../helpers/avatar";

/**
 * Conteúdo do avatar de grupo: mostra a foto do grupo quando existe e carrega,
 * com fallback pras iniciais (quando não há foto ou a imagem falha ao carregar).
 * Renderiza DENTRO do círculo estilizado de cada tela — que dá tamanho, cor de
 * fundo e o recorte (overflow: hidden) da imagem.
 */
const GroupAvatar = ({name, photoUrl}) => {
    const [failed, setFailed] = React.useState(false);
    // Reseta o estado de falha quando a foto muda (troca de grupo/campanha).
    React.useEffect(() => { setFailed(false); }, [photoUrl]);

    if (photoUrl && !failed) {
        return <img src={photoUrl} alt={name || ""} onError={() => setFailed(true)}/>;
    }
    return <>{initials(name)}</>;
};

GroupAvatar.propTypes = {
    name: PropTypes.string,
    photoUrl: PropTypes.string,
};

export default GroupAvatar;
